import { ReportColumnPersonalizationFlags } from '../columnUtils.types';
import {
  SaleCostAdjustmentsReportTableGroupingColumnId,
  SaleCostAdjustmentsReportTableValueColumnId,
} from './saleCostAdjustmentsColumnUtils.types';

export const SALE_COST_ADJUSTMENTS_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [SaleCostAdjustmentsReportTableGroupingColumnId.AuditDateTime]: {
    isDateTime: true,
  },
  [SaleCostAdjustmentsReportTableValueColumnId.TotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SaleCostAdjustmentsReportTableValueColumnId.PreviousTotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [SaleCostAdjustmentsReportTableValueColumnId.TotalCostChangeInCurrentCurrency]:
    {
      isNumeric: true,
      isCurrency: true,
    },
  [SaleCostAdjustmentsReportTableValueColumnId.QuantitySold]: {
    isNumeric: true,
    isInteger: true,
  },
  [SaleCostAdjustmentsReportTableValueColumnId.PreviousQuantitySold]: {
    isNumeric: true,
    isInteger: true,
  },
  [SaleCostAdjustmentsReportTableValueColumnId.QuantityChange]: {
    isNumeric: true,
    isInteger: true,
  },
};
